import { render, staticRenderFns } from "./NewRequest.vue?vue&type=template&id=9b0a5c7c&scoped=true&"
import script from "./NewRequest.vue?vue&type=script&lang=js&"
export * from "./NewRequest.vue?vue&type=script&lang=js&"
import style0 from "./NewRequest.vue?vue&type=style&index=0&id=9b0a5c7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0a5c7c",
  null
  
)

export default component.exports